.Newsletter-container {
  --header-color: var(--cbssports-newsletter-header-color, #181818);
  --intro-color: var(--cbssports-newsletter-intro-color, #5f5f5f);
  --disclosure-color: var(--cbssports-newsletter-disclosure-color, #767676);
  --agreement-color: var(--cbssports-newsletter-agreement-color, #767676);
  --link-color: var(--cbssports-newsletter-link-color, #181818);
  --input-text-color: var(--cbssports-newsletter-input-text-color, #181818);
  --checkbox-color: var(--cbssports-newsletter-checkbox-color, #ffffff00);
  --checkbox-hover-color: var(
    --cbssports-newsletter-checkbox-hover-color,
    #f5f8ff
  );
  --link-hover-color: var(--cbssports-newsletter-link-hover-color, #0036b5);
  --input-placeholder-color: var(
    --cbssports-newsletter-input-placeholder-color,
    #5f5f5f
  );
  --input-background-color: var(
    --cbssports-newsletter-input-background-color,
    #ffffff00
  );
  --background-color: var(--cbssports-newsletter-background-color, #ffffff00);
  background-color: var(--background-color);
}

.Newsletter-container[data-mobile-app='true'] {
  @media (prefers-color-scheme: dark) {
    --cbssports-newsletter-header-color: #ffffff;
    --cbssports-newsletter-intro-color: #ffffff;
    --cbssports-newsletter-agreement-color: #ffffff;
    --cbssports-newsletter-disclosure-color: #ffffff;
    --cbssports-newsletter-link-color: #ffffff;
    --cbssports-newsletter-link-hover-color: #ffffff;
    --cbssports-newsletter-checkbox-color: #181818;
    --cbssports-newsletter-checkbox-hover-color: #181818;
  }
}

.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid rgb(0, 74, 206);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 1s linear infinite;
}

.loader-div {
  min-height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Newsletter {
  text-align: center;
}

.Newsletter.check .Newsletter-stateCheck {
  display: block;
}

.Newsletter-stateSent {
  display: block;
  margin: auto;
  text-align: center;
  padding: 0;
  border: 0;
  font: inherit;
  box-sizing: border-box;
}

.Newsletter-stateFail {
  display: block;
  margin: auto;
  text-align: center;
  padding: 0;
  border: 0;
  font: inherit;
  box-sizing: border-box;
}

.Newsletter--secondary .Newsletter-intro,
.Newsletter--secondary .Newsletter-title,
.Newsletter--secondary .Newsletter-title--small,
.Newsletter--secondary .Newsletter-description,
.Newsletter--secondary .Newsletter-description--small,
.Newsletter--secondary .CheckButton-text,
.Newsletter--secondary .Newsletter-promise {
  color: #fff;
}

.Newsletter-stateCheck {
  margin-top: 12px;
}

.Newsletter-stateCheck {
  color: #cc0e00;
}

.Newsletter-inputForm {
  margin-top: 16px;
  display: block;
}

figure .img {
  box-sizing: border-box;
  display: block;
  margin: 0;
  padding: 0;
}

.Newsletter-intro {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-weight: 400;
  color: var(--intro-color);
  font-size: 13px;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 12px;
}

@media (min-width: 800px) {
  .Newsletter-intro {
    font-size: 0.875rem;
    letter-spacing: 4px;
  }
}

.Newsletter-title {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 1.25rem;
  font-weight: 900;
  color: var(--header-color);
  letter-spacing: -0.03em;
  margin-bottom: 8px;
}

@media (min-width: 800px) {
  .Newsletter-title {
    font-size: 2rem;
    font-weight: 900;
  }
}

@media (max-width: 559px) {
  .Newsletter-title {
    font-size: 1.5rem;
    line-height: 1.2;
  }
}

.Newsletter-title--small {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  color: var(--header-color);
  margin-bottom: 8px;
}

@media (min-width: 800px) {
  .Newsletter-title--small {
    font-size: 1.5rem;
    font-weight: 700;
  }
}

@media (max-width: 559px) {
  .Newsletter-title--small {
    font-size: 1.5rem;
    font-weight: 700;
  }
}

.Newsletter-description {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: var(--header-color);
  line-height: 1.2;
}

@media (min-width: 800px) {
  .Newsletter-description {
    font-size: 1.125rem;
    line-height: 1.6;
  }
}

.Newsletter-description--small {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: var(--header-color);

  line-height: 1.2;
}

.Newsletter-checkbox {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 16px 0 0;
  position: relative;
}

.Newsletter-promise {
  color: var(--intro-color);
  font-size: 11px;
  margin-top: 12px;
  opacity: 0.6;
}

.Newsletter-optIn {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  margin-top: 20px;
}

.Newsletter-optIn .Newsletter-optInLink {
  font-weight: 700;
}

.Newsletter-seeAll {
  font-weight: 400;
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--header-color);
  margin-top: 24px;
}

@media (min-width: 800px) {
  .Newsletter-seeAll {
    margin-top: 12px;
  }
}

.Newsletter-image {
  margin: 0 auto 15px;
  width: 80px;
}

@media (min-width: 560px) {
  .Newsletter-image {
    margin-bottom: 24px;
    width: 100px;
  }
}

.Newsletter-image img {
  border-radius: 4px;
  overflow: hidden;
}

.Newsletter-container--marker {
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  margin: 30px 0;
  padding: 24px;
  text-align: left;
}

@media (min-width: 800px) {
  .Newsletter-container {
    padding: 32px;
  }
}

.Newsletter-container--marker {
  border-radius: 2px;
  margin-left: auto;
  margin-right: auto;
  max-width: 468px;
  padding: 1em;
}

@media (max-width: 799px) {
  .Newsletter-container--marker {
    border-left: none;
    border-right: none;
  }
}

.Newsletter-container--marker .Newsletter-header {
  display: flex;
}

.Newsletter-container--marker .Newsletter-image {
  flex-shrink: 0;
  margin-right: 12px;
  width: 70px;
}

.Newsletter-container--marker .Newsletter-texts {
  flex-grow: 1;
}

.Newsletter-container--marker .Newsletter-texts * {
  text-align: left;
  margin: 0;
  padding: 0;
}

.Newsletter-container--marker .Newsletter-intro {
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0em;
  line-height: 1;
  padding: 0 0 4px;
  text-transform: inherit;
}

@media (max-width: 799px) {
  .Newsletter-container--marker .Newsletter-intro {
    font-size: 1rem;
    line-height: 1;
  }
}

.Newsletter-container--marker .Newsletter-description {
  font-size: 1rem;
  line-height: 1.2;
  color: var(--intro-color);
  padding: 0;
}

@media (max-width: 799px) {
  .Newsletter-container--marker .Newsletter-description {
    font-size: 0.875rem;
  }
}

.Newsletter-container--marker .Newsletter-image {
  margin-bottom: 0;
}

.CheckButton,
.CheckButton-newsletter {
  justify-content: center;
}

.Newsletter-container--marker .CheckButton-newsletter {
  line-height: 1.3;
  align-items: center;
  display: flex;
}

.Newsletter-container--marker .CheckButton-text {
  font-weight: 400;
  color: var(--disclosure-color);
}

.CheckButton-text,
.RadioButtonText {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  align-items: center;
  color: var(--header-color);
  display: flex;
}

.CheckButton {
  cursor: pointer;
  display: flex;
  position: relative;
  text-align: left;
}

.CheckButton-checkbox {
  letter-spacing: 0em;
  background-color: var(--checkbox-color);
  border: 1px solid #dcdcdc;
  cursor: pointer;
  display: inline-block;
  height: 18px;
  position: relative;
  text-transform: none;
  vertical-align: bottom;
  width: 18px;
  border-radius: 4px;
  appearance: none;
  display: flex;
  flex: 1 0 auto;
  max-width: 18px;
}

.CheckButton-checkbox:hover {
  background-color: var(--cbssports-newsletter-checkbox-hover-color);
  border: 1px solid #0036b5;
}

.CheckButton-checkbox::after {
  border: solid #004ace;
  border-width: 0 3px 3px 0;
  content: '';
  display: none;
  height: 10px;
  left: 5px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg);
  width: 3px;
}

.CheckButton-checkbox:checked::after {
  display: block;
}

.CheckButton-text {
  line-height: 1;
  margin-left: 4px;
}

.Form-inputText {
  -moz-appearance: none;
  -webkit-appearance: none;
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-weight: 400;
  appearance: none;
  background-color: var(--input-background-color);
  border: 1px solid #dcdcdc;
  border-radius: 2px;
  box-sizing: border-box;
  outline: none;
  resize: none;
  text-align: center;
  vertical-align: top;
  width: 100%;
  font-size: 0.75rem;
  padding: 8px 10px 9px;
}

.Form-inputText::placeholder {
  color: var(--input-placeholder-color);
  opacity: 1;
}

.Form-inputText:-ms-input-placeholder {
  color: var(--input-placeholder-color);
}

.Form-inputText::-ms-input-placeholder {
  color: var(--input-placeholder-color);
}

.Form-inputText:focus {
  border-color: #004ace;
}

@media (min-width: 800px) {
  .Form-inputText {
    text-align: left;
    width: 250px;
  }
}

@media (min-width: 800px) {
  .Form-inputText {
    font-size: 0.875rem;
    padding: 11px 12px 10px;
  }
}

@media (min-width: 800px) {
  .Form-inputText {
    border-radius: 2px 0 0 2px;
    height: 44px;
    padding-bottom: 0;
    padding-top: 0;
  }
}
.Newsletter-container--marker .CheckButton-checkbox {
  display: flex;
  flex-shrink: 0;
  margin-top: 2px;
}

.Newsletter-container--marker .Newsletter-checkbox {
  flex-grow: 0;
  margin-bottom: 0;
}

.Newsletter-container--marker .Newsletter-optIn {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--agreement-color);
  margin-top: 20px;
}

.Newsletter-container--marker .Newsletter-optIn .Newsletter-optInLink {
  font-weight: 400;
}

.Newsletter-container--marker .Newsletter-emailAddress {
  display: flex;
  flex-grow: 1;
}

.Newsletter-container--marker .Newsletter-stateNotSent {
  text-align: left;
}

.Newsletter-container--marker .Newsletter-stateSent .Newsletter-title {
  margin-top: 0;
}

.Newsletter-container--marker .Newsletter-form {
  font-size: 0.75rem;
  font-weight: 400;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.Newsletter-container--marker .Newsletter-inputForm {
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
}

@media (max-width: 799px) {
  .Newsletter-container--marker .Newsletter-inputForm {
    flex-direction: column;
  }
}

.Form-submitButton--primary {
  font-family: 'FS Industrie', 'FSIndustrie-Bold', Helvetica, Arial, sans-serif;
  font-weight: 400;
  letter-spacing: 0em;
  line-height: 1;
  border-radius: 2px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  text-transform: none;
  transition: background-color 0.2s ease;
  background-color: #004ace;
  border: 1px solid #004ace;
  color: #fff;
  font-size: 0.75rem;
  padding: 8px;
  width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  margin: 12px 0 0 0;
  width: 100%;
}

.Form-submitButton--primary:hover {
  background-color: #0036b5;
  color: #fff;
}

@media (min-width: 800px) {
  .Form-submitButton--primary {
    font-size: 0.875rem;
    padding: 12px 40px;
  }
}

@media (min-width: 800px) {
  .Form-submitButton--primary {
    border-radius: 0 2px 2px 0;
    height: 44px;
    padding-bottom: 0;
    padding-top: 0;
  }
}

@media (min-width: 800px) {
  .Form-submitButton--primary {
    margin: 0;
    width: auto;
  }
}

.Newsletter-container a:link,
.Newsletter-container a:visited {
  color: var(--link-color);
  text-decoration: none;
  transition: color 0.2s ease;
}

.Newsletter-container a:hover,
.Newsletter-container a:active {
  color: var(--link-hover-color);
}

.Newsletter-container--marker h4,
.Newsletter-container--marker h5 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: var(--header-color);
  padding: 16px 0;
}

@media (max-width: 799px) {
  .Newsletter-container--marker .Newsletter-image {
    width: 60px;
  }
}

.Newsletter-container--marker figure img {
  height: auto;
  width: 100%;
}

.Newsletter-container--marker {
  min-height: 275px;
}

.Newsletter-container[data-type='banner'] {
  min-height: 357px;
}

@media (max-width: 799px) {
  .Newsletter-container--marker {
    min-height: 290.5px;
  }
}

.Newsletter-icon {
  margin-bottom: 10px;
  position: relative;
}

.Newsletter-icon:before {
  border: 2px solid #5f5f5f;
  border-radius: 50%;
  content: '';
  display: inline-block;
  padding: 20px;
  box-sizing: content-box;
}

.Newsletter-icon > svg {
  -ms-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  fill: #059646;
  stroke: #059646;
  font-size: 22px;
  left: 50%;
  position: absolute;
  top: 8px;
}

.Hidden {
  display: none;
}

.Flex {
  display: flex;
}

h1,
h2,
h3,
h4,
h5,
h6,
figure {
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
  margin-inline-start: 0 !important;
  margin-inline-end: 0 !important;
  padding-block-start: 0 !important;
  padding-block-end: 0 !important;
  padding-inline-start: 0 !important;
  padding-inline-end: 0 !important;
}
